import { SITE } from '@/config/site';

const RM = SITE.currencySymbol;

export default {
  'common.currency': { mm: RM, en: RM, ms: RM },

  'home.name': { mm: 'အမည်', en: 'Username', ms: 'Nama pengguna' },
  'home.balance': { mm: 'လက်ကျန်ငွေ', en: 'Balance', ms: 'Baki' },
  'home.phoneShort': { mm: 'ဖုန်း', en: 'Phone', ms: 'Telefon' },
  'home.withdraw': { mm: 'ငွေထုတ်', en: 'Withdraw', ms: 'Pengeluaran' },

  'deposit.minAmount': {
    mm: `ငွေပမာဏအနည်းဆုံး ${SITE.minDeposit} ${RM} ထည့်ပေးပါ။`,
    en: `Please enter at least ${SITE.minDeposit} ${RM}`,
    ms: `Sila masukkan sekurang-kurangnya ${SITE.minDeposit} ${RM}`,
  },
  'withdraw.minAmount': {
    mm: `ငွေပမာဏအနည်းဆုံး ${SITE.minWithdraw} ${RM} ထည့်ပေးပါ။`,
    en: `Please enter at least ${SITE.minWithdraw} ${RM}`,
    ms: `Sila masukkan sekurang-kurangnya ${SITE.minWithdraw} ${RM}`,
  },
};
